module.exports = __webpack_public_path__ + "static/media/user-icon.626b650b.png";